import { motion } from "framer-motion";
import { fadeUp } from "../animations/variants";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-white text-reddark min-h-screen flex items-center justify-center px-6 pt-[80px]">
      <div className="text-center max-w-3xl">
        {/* 404 Big Text */}
        <motion.h1
          variants={fadeUp}
          initial="hidden"
          animate="show"
          className="text-[120px] md:text-[180px] font-extrabold text-reddark leading-none animate-neonFlicker"
        >
          404
        </motion.h1>

        {/* Subtitle */}
        <motion.h2
          variants={fadeUp}
          initial="hidden"
          animate="show"
          transition={{ delay: 0.2 }}
          className="text-2xl md:text-4xl font-semibold mt-6"
        >
          Page Not Found
        </motion.h2>

        {/* Description */}
        <motion.p
          variants={fadeUp}
          initial="hidden"
          animate="show"
          transition={{ delay: 0.4 }}
          className="text-gray-400 mt-4"
        >
          The page you're looking for doesn’t exist or has been moved.
        </motion.p>

        {/* Buttons */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          animate="show"
          transition={{ delay: 0.6 }}
          className="mt-10 flex flex-col sm:flex-row gap-6 justify-center"
        >
          <button
            onClick={() => navigate("/")}
            className="px-8 py-3 bg-reddark text-white rounded-full font-semibold hover:bg-gray-800 transition"
          >
            Back Home
          </button>

          <button
            onClick={() => navigate("/contact")}
            className="px-8 py-3 border border-reddark text-reddark rounded-full font-semibold hover:bg-reddark hover:text-white transition"
          >
            Contact Us
          </button>
        </motion.div>
      </div>
    </div>
  );
};

export default NotFound;
